const packageName = 'entities'

export const RESET = `${packageName}/RESET`
